var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightBasic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967L14.2676 9.20693L14.2891 9.22846C14.6668 9.60615 14.9821 9.9214 15.2186 10.2C15.4653 10.4906 15.67 10.7902 15.787 11.1502C15.9664 11.7025 15.9664 12.2975 15.787 12.8498C15.67 13.2098 15.4653 13.5094 15.2186 13.8C14.9821 14.0786 14.6668 14.3938 14.2891 14.7715L14.2676 14.7931L10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303C9.17678 18.2374 9.17678 17.7626 9.46967 17.4697L13.2069 13.7324C13.6117 13.3276 13.883 13.0555 14.0751 12.8292C14.2615 12.6096 14.329 12.4829 14.3604 12.3863C14.442 12.1352 14.442 11.8648 14.3604 11.6137C14.329 11.5171 14.2615 11.3904 14.0751 11.1708C13.883 10.9444 13.6117 10.6724 13.2069 10.2676L9.46967 6.53033C9.17678 6.23744 9.17678 5.76256 9.46967 5.46967Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBasic);
export default __webpack_public_path__ + "static/media/arrow-right-basic.39b440e9.svg";
export { ForwardRef as ReactComponent };